
<div class="row bg-white pt-3 pb-3">
    <div class="col-12 mt-3 mb-5">
        <h3 class="mb-4">Token Management Screens V2</h3>
        <div class="_token-queue-dashboard-wrapper">
            <div class="_token-dash-left-section">
                <div class="_token-container">
                    <div class="_token-top-heading">
                        <label>Token</label>
                    </div>
                    
                    <div class="_token-round">
                        <span>8</span>
                    </div>
                    <div class="_token-round">
                        <span>10</span>
                    </div>
                    <div class="_token-round">
                        <span>11</span>
                    </div>
                    <div class="_token-round">
                        <span>15</span>
                    </div>
                    <div class="_token-round">
                        <span>16</span>
                    </div>
                    <div class="_token-round">
                        <span>17</span>
                    </div>
                    <div class="_token-round">
                        <span>18</span>
                    </div>
                    <div class="_token-round">
                        <span>19</span>
                    </div>
                </div>
                <div class="_token-visit-container">
                    <div class="_token-top-heading">
                        <label>Visit Status</label>
                    </div>
                    
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status2.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status2.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status2.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status2.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status1.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status1.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status1.svg">
                    </div>
                    <div class="_visit-status">
                        <img class="_visit-status-icon" src="/assets/images/icons/status1.svg">
                    </div>                    
                    
                </div>
            </div>
            <div class="_token-dash-right-section">
                <div class="_token-service-status-container">
                    <div class="_token-top-heading">
                        <div class="_desk-square">
                            <label>E</label>
                        </div>
                    </div>
                    
                    <div class="_service-status-indicator _status-completed">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-completed">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-in-progress">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-in-progress">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="_token-service-status-container">
                    <div class="_token-top-heading">
                        <div class="_desk-square">
                            <label>S</label>
                        </div>
                    </div>
                    
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="_token-service-status-container">
                    <div class="_token-top-heading">
                        <div class="_desk-square">
                            <label>D</label>
                        </div>
                    </div>
                    
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                    <div class="_service-status-indicator _status-pending">
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </div>
                </div>
                
            </div>
        </div>
